const routes = [
    {
        path: "/reservations",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'reservation_index'
        }
    }
];

export default routes;
